// extracted by mini-css-extract-plugin
export default {"emptyImg":"no-image-view_emptyImg__VAekX","round":"no-image-view_round__qniCx"};